import { _GROUPS } from "@/store/_PERMISSIONS"

// -- FIELDS
const _FIELDS = []

// -- HEADERS
const _HEADERS = [
  {
    text: "Data",
    align: "left",
    value: "data"
  },
  {
    text: "Titulo",
    align: "left",
    value: "titulo"
  },
  {
    text: "Descrição",
    align: "left",
    value: "descricao"
  },
  {
    text: "Destinatários",
    align: "left",
    value: "total"
  },
  {
    text: "Ações",
    value: "action"
  }
]

const NOTIFICACAO = {
  _FIELDS: _FIELDS,
  _HEADERS: _HEADERS
}

export default NOTIFICACAO
